const avatarColorSchemes = [
  { avatarBg: '#E14E14', avatarBorder: '#5B2B16' },
  { avatarBg: '#DF006F', avatarBorder: '#5C1B47' },
  { avatarBg: '#0E3FD4', avatarBorder: '#080345' },
  { avatarBg: '#791CEA', avatarBorder: '#3C245D' },
  { avatarBg: '#006D6D', avatarBorder: '#00373E' },
];

export {
  avatarColorSchemes,
};